/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetCreditFacilitiesWithLiabilityAccountsQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
}>;


export type GetCreditFacilitiesWithLiabilityAccountsQueryGQLType = (
  { __typename?: 'Query' }
  & { creditFacilities: Array<(
    { __typename?: 'CreditFacility' }
    & Pick<Types.CreditFacilityGQLType, 'id' | 'name'>
    & { liabilityAccounts: Array<(
      { __typename?: 'AccountingAccount' }
      & Pick<Types.AccountingAccountGQLType, 'tAccount'>
    )> }
  )> }
);


export const GetCreditFacilitiesWithLiabilityAccountsDocumentGQLType = gql`
    query GetCreditFacilitiesWithLiabilityAccounts($organizationId: UUID!) {
  creditFacilities(organizationId: $organizationId) {
    id
    name
    liabilityAccounts {
      tAccount
    }
  }
}
    `;

/**
 * __useGetCreditFacilitiesWithLiabilityAccountsQuery__
 *
 * To run a query within a React component, call `useGetCreditFacilitiesWithLiabilityAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditFacilitiesWithLiabilityAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditFacilitiesWithLiabilityAccountsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetCreditFacilitiesWithLiabilityAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetCreditFacilitiesWithLiabilityAccountsQueryGQLType, GetCreditFacilitiesWithLiabilityAccountsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditFacilitiesWithLiabilityAccountsQueryGQLType, GetCreditFacilitiesWithLiabilityAccountsQueryVariablesGQLType>(GetCreditFacilitiesWithLiabilityAccountsDocumentGQLType, options);
      }
export function useGetCreditFacilitiesWithLiabilityAccountsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditFacilitiesWithLiabilityAccountsQueryGQLType, GetCreditFacilitiesWithLiabilityAccountsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditFacilitiesWithLiabilityAccountsQueryGQLType, GetCreditFacilitiesWithLiabilityAccountsQueryVariablesGQLType>(GetCreditFacilitiesWithLiabilityAccountsDocumentGQLType, options);
        }
export type GetCreditFacilitiesWithLiabilityAccountsQueryHookResult = ReturnType<typeof useGetCreditFacilitiesWithLiabilityAccountsQuery>;
export type GetCreditFacilitiesWithLiabilityAccountsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetCreditFacilitiesWithLiabilityAccountsLazyQueryGQLType>;
export type GetCreditFacilitiesWithLiabilityAccountsQueryResultGQLType = Apollo.QueryResult<GetCreditFacilitiesWithLiabilityAccountsQueryGQLType, GetCreditFacilitiesWithLiabilityAccountsQueryVariablesGQLType>;